import superAdmin from "./superAdmin";
import admin from "./admin";
import common from "./common";

export default {
    common: common,
    admin: admin,
    superAdmin: superAdmin
}